import { LeftSocialMediaIconUI } from "../../components/LeftSocialMediaIconUI";

const List_Of_Tenders = () => {
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img
            src="assets/img/Banner/portal-banner7.jpg"
            className="img-fluid"
            alt="image"
          />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> Find Plumber Details </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner-title2">
                <h3 className="fontSizeClass">{"List Of Tenders"} </h3>
              </div>
              <div className="mayor-table depart Tender_batra">
                <table className="table table-bordered">
                  <thead>
                    <tr className="table-warning table-bor-2">
                      <th scope="col">{"Tender"}</th>
                      <th scope="col"> {"Tender Uploaded On"} </th>
                      <th scope="col"> {"Action"} </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td scope="row">
                        {
                          "MISCELLANEOUS URGENT REPAIRING OF LIGHTING SYSTEM ARRANGEMENT AND OTHER ALLIED WORKS AT VARIOUS PLACES IN WARD NO:47"
                        }
                      </td>
                      <td> 07/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "CLEANING OF WATER BODY AT 47 NARKELDANGA MAIN ROAD IN WARD NO-033 FOR SECURING COMPLIANCE OF NOTICE U/S 496A"
                        }
                        1866(09/12/2022)
                      </td>
                      <td> 06/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "REPAIRING OF DAMAGED 52 NOS. G.I. HAND CARTS, IN WARD NO.-21 & 22 UNDER A.D./SWM-I/BR.-IV."
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "SUPPLYING OF SPARES WITH FITTING AND FIXING FOR DAMAGED 40 NOS. TRI-CYCLE PADDLE VAN IN WARDS NO.-68,69 & 90 UNDER A.D./SWM-I/BR.-VIII."
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "SUPPLYING OF SPARES WITH FITTING AND FIXING FOR DAMAGED 45 NOS. TRI-CYCLE PADDLE VAN IN ALL WARDS UNDER A.D./SWM-I/BR.-VII."
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "SUPPLYING OF SPARES WITH FITTING AND FIXING FOR DAMAGED 44 NOS. TRI-CYCLE PADDLE VAN IN ALL WARDS, UNDER A.D./SWM-I/BR.-VI"
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "SUPPLYING OF SPARES WITH FITTING AND FIXING FOR DAMAGED 42 NOS. TRI-CYCLE PADDLE VAN IN WARDS NO.-41,43,44 UNDER A.D./SWM-I/BR.-V"
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "REPAIRING OF DAMAGED 60 NOS. G.I. HAND CARTS, IN WARDS NO.-21,22,24,25,26,28,38 & 39 UNDER A.D./SWM-I/BR.-IV"
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "SUPPLYING OF SPARES WITH FITTING AND FIXING FOR DAMAGED 40 NOS. TRI-CYCLE PADDLE VAN IN WARDS NO.-21,22,24,25,26,28,38 & 39 UNDER A.D./SWM-I/BR.-IV"
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "SUPPLYING OF SPARES WITH FITTING AND FIXING FOR DAMAGED 40 NOS. TRI-CYCLE PADDLE VAN IN WARDS NO.-1,3,5 & 6 UNDER A.D./SWM-I/BR.-I."
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "REPAIRING & REPLACEMENT OF OLD & DEFECTIVE ELECTRICAL ACCESSORIES AT ROXY BUILDING UNDER BR-VI KMC LTG/16/INST/46/VI/Z-II/24-25"
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "ELECTRIFICATION WORKS REQUIRED FOR 3 NOS KMCP SCHOOLS AT 33 GARDENER LANE, 49/1 DURGA CHARAN DOCTOR LANE & 35 CANTOPHER LANE UNDER BR-VI, KMC"
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td scope="row">
                        {
                          "Urgent repairing ,re-winding including mechanicql seal changing with qllied Works of one submersible pump unit no.4 at LS-2 (Thakery Road) DPS under PBPS(Drg.)/S&D"
                        }
                      </td>
                      <td> 03/08/2024 </td>
                      <td>
                        <a className="fontSizeClass" href="" target="_blank">
                          {"Download"}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default List_Of_Tenders;
